import ContentWrapper from "../../../components/Add/ContentWrapper";
import Breadcrumbs from "../../../components/breadcrumbs/Breadcrumbs";
import { DynamicFilterConfig } from "../../../components/DynamicComponent/DynamicFilterPanel";
import BalanceSheetTable from "../../../components/GridTable/BalanceSheet";
import { useEffect } from "react";
import { useDispatch } from 'react-redux';
import { useLocation } from "react-router";
import { setListOfBalanceSheetUrl } from '../../../store/slices/selectedBankIdSlice';

export default function BalanceSheet() {
    const dispatch = useDispatch();
    const location = useLocation();
    useEffect(() => {
        dispatch(setListOfBalanceSheetUrl(location.pathname + location.search));
    }, [location.pathname, location.search, dispatch]);
    const dynamicFilterConfig: DynamicFilterConfig = {
        "Date Range": {
      label: "Date Range",
      type: "date",
      required: false, 
            searchKey: {
                start: "start_date",
                end: "end_date",
            },
    },
    }
    return (
        <div>
            <Breadcrumbs
                navPath={["Zoodpay Money", "Balance Sheet"]}
                heading="Balance Sheet"
                noNavigation
                list={true}
            />
            <BalanceSheetTable
                staticText={{ emptyScreenText: { heading1: "No Data", heading2: "No records found." } }}
                mainEndPoint={"balance-sheet"}
                filters={true}
                exporting={true}
                dynamicFilterConfig={dynamicFilterConfig}
                customHeight="h-[103px]"
            />
        </div>
    )
}
